import { createContext } from "react";
import { AccessControlContextProps } from "./types";

const initialAccessControlContextValue = {
  userInfo: {},
};

export const AccessControlContext = createContext<AccessControlContextProps>(
  initialAccessControlContextValue
);
